export default __webpack_public_path__ + "static/media/p2023-2.0b811ab3.jpeg";